export default {"src":"/_next/static/media/confetti-outline-light.03439dc5.gif","height":400,"width":400};